// src/falco-config-data.js
var NEO = { hex: null, name: "Néochrome", neo: true };
var MULTI = { hex: null, name: "Multicolore", multi: true };
var c = (hex, name) => ({ hex, name });
var CERCLAGE_UNI = [c("#242424", "Noir brillant"), c("#101010", "Noir mat"), c("#FF0000", "Rouge"), c("#FF6F00", "Orange"), c("#001EFF", "Bleu"), c("#0084FF", "Bleu Turquoise"), c("#FFC300", "Gold"), c("#FF00EA", "Rose"), c("#00FF00", "Vert"), c("#B9B9B9", "Aluminium"), c("#CC00FF", "Violet"), c("#916D55", "Bronze"), c("#ffffff", "Blanc")];
var CERCLAGE_NET_BAS = [c("#141414", "Noir"), c("#ffffff", "Blanc")];
var CERCLAGE_NET_HAUT = [c("#FF6F00", "Orange"), c("#FF0000", "Rouge"), c("#001EFF", "Bleu"), c("#0084FF", "Bleu Turquoise"), c("#FFC300", "Gold"), c("#00FF00", "Vert"), c("#B9B9B9", "Chrome"), c("#CC00FF", "Violet"), c("#916D55", "Bronze"), c("#ffffff", "Blanc"), c("#FF00EA", "Rose"), c("#EEFF00", "Jaune Fluo")];
var CERCLAGE_FADE = [c("#001EFF", "Bleu"), c("#CC00FF", "Violet"), c("#FF6F00", "Orange"), c("#FF0000", "Rouge"), c("#FFC300", "Gold"), c("#00FF00", "Vert"), c("#B9B9B9", "Aluminium"), c("#916D55", "Bronze"), c("#141414", "Noir")];
var RAYONS = [c("#000000", "Noir"), c("#B9B9B9", "Chrome"), c("#ffffff", "Blanc"), NEO];
var RAYONS_FADE = [c("#000000", "Noir"), c("#ffffff", "Blanc"), c("#B9B9B9", "Chrome blanc"), NEO];
var TETES_UNI = [c("#141414", "Noir"), c("#FF0000", "Rouge"), c("#FF6F00", "Orange"), c("#001EFF", "Bleu"), c("#0084FF", "Bleu Turquoise"), c("#FFC300", "Gold"), c("#00FF00", "Vert"), c("#B9B9B9", "Aluminium"), c("#CC00FF", "Violet"), c("#916D55", "Bronze"), c("#FF00EA", "Rose"), MULTI, NEO];
var TETES_NET = [c("#141414", "Noir"), c("#FF6F00", "Orange"), c("#FF0000", "Rouge"), c("#001EFF", "Bleu"), c("#0084FF", "Bleu Turquoise"), c("#FFC300", "Gold"), c("#00FF00", "Vert"), c("#B9B9B9", "Chrome"), c("#CC00FF", "Violet"), c("#916D55", "Bronze"), c("#FF00EA", "Rose"), MULTI, NEO];
var TETES_FADE_BASSES = [c("#FF0000", "Rouge"), c("#000000", "Noir"), c("#FF6F00", "Orange"), c("#001EFF", "Bleu"), c("#0084FF", "Bleu Turquoise"), c("#FFC300", "Gold"), c("#00FF00", "Vert"), c("#B9B9B9", "Aluminium"), c("#CC00FF", "Violet"), c("#916D55", "Bronze"), c("#FF00EA", "Rose"), MULTI, NEO];
var TETES_FADE_HAUTES = [c("#FF0000", "Rouge"), c("#000000", "Noir"), c("#FF6F00", "Orange"), c("#001EFF", "Bleu"), c("#0084FF", "Bleu Turquoise"), c("#FFC300", "Gold"), c("#00FF00", "Vert"), c("#B9B9B9", "Aluminium"), c("#CC00FF", "Violet"), c("#916D55", "Bronze"), c("#FF00EA", "Rose"), MULTI, NEO];
var MOYEUX_UNI = [c("#141414", "Noir brillant"), c("#FF0000", "Rouge"), c("#FF6F00", "Orange"), c("#001EFF", "Bleu"), c("#0084FF", "Bleu Turquoise"), c("#FFC300", "Gold"), c("#00FF00", "Vert"), c("#B9B9B9", "Aluminium"), c("#CC00FF", "Violet"), c("#916D55", "Bronze"), c("#FF00EA", "Rose"), c("#ffffff", "Blanc"), NEO, c("#212121", "Noir mat")];
var MOYEUX_NET = [c("#181818", "Noir brillant"), c("#101010", "Noir mat"), c("#FF6F00", "Orange"), c("#FF0000", "Rouge"), c("#001EFF", "Bleu"), c("#0084FF", "Bleu Turquoise"), c("#FFC300", "Gold"), c("#00FF00", "Vert"), c("#B9B9B9", "Chrome"), c("#CC00FF", "Violet"), c("#ffffff", "Blanc"), c("#916D55", "Bronze"), c("#FF00EA", "Rose"), NEO, c("#EEFF00", "Jaune Fluo")];
var MOYEUX_FADE = MOYEUX_NET.slice(0, 14);
var T = (label, target, finishes, defaultIndex, thumb) => ({ label, target, finishes, defaultIndex, thumb });
var modes = [
  { id: "uni", label: "Couleur unique", description: "Une seule couleur sur les deux cerclages.", categories: [
    T("Cerclage", "cerclage_uni", CERCLAGE_UNI, 0, "cerclage"),
    T("Rayons", "rayons", RAYONS, 0, "rayons"),
    T("Têtes", "tetes", TETES_UNI, 11, "tetes-rayons"),
    T("Moyeux", "moyeux", MOYEUX_UNI, 8, "moyeux")
  ] },
  { id: "degrade-net", label: "Dégradé net", description: "Deux couleurs séparées par une ligne franche.", categories: [
    T("Cerclage bas", "cerclage_bas", CERCLAGE_NET_BAS, 0, "cerclage"),
    T("Cerclage haut", "cerclage_haut", CERCLAGE_NET_HAUT, 0, "cerclage"),
    T("Rayons", "rayons", RAYONS_FADE, 0, "rayons"),
    T("Têtes", "tetes", TETES_NET, 11, "tetes-rayons"),
    T("Moyeux", "moyeux", MOYEUX_NET, 4, "moyeux")
  ] },
  { id: "degrade-fade", label: "Dégradé fondu", description: "Deux couleurs avec transition progressive.", categories: [
    T("Cerclage bas", "cerclage_bas", CERCLAGE_FADE, 0, "cerclage"),
    T("Cerclage haut", "cerclage_haut", CERCLAGE_FADE, 3, "cerclage"),
    T("Rayons", "rayons", RAYONS, 0, "rayons"),
    T("Têtes basses", "tetes_basses", TETES_FADE_BASSES, 11, "tetes-rayons"),
    T("Têtes hautes", "tetes_hautes", TETES_FADE_HAUTES, 11, "tetes-rayons"),
    T("Moyeux", "moyeux", MOYEUX_FADE, 4, "moyeux")
  ] }
];
function defaultSelection(mode) {
  const m = modes.find((x) => x.id === mode) || modes[0];
  const sel = {};
  m.categories.forEach((cat) => {
    sel[cat.target] = cat.finishes[cat.defaultIndex] || cat.finishes[0];
  });
  return sel;
}
var assets = () => window.Falco?.assets || {};
var thumbUrl = (name) => (assets().neo || "").replace(/configurateur-neochrome\.webp/, `configurateur-${name}.webp`);

// src/falco-configurator.js
var PART_ICON = {
  cerclage: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" class="size-4"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="6.2"/></svg>',
  rayons: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" class="size-4"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="2"/><path d="M12 3.2v6.8M12 14v6.8M3.2 12H10M14 12h6.8M5.8 5.8l4.8 4.8M13.4 13.4l4.8 4.8M18.2 5.8l-4.8 4.8M10.6 13.4l-4.8 4.8"/></svg>',
  tetes: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" class="size-4"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="3.6" r="1.5" fill="currentColor" stroke="none"/><circle cx="18.4" cy="8.2" r="1.5" fill="currentColor" stroke="none"/><circle cx="16" cy="18" r="1.5" fill="currentColor" stroke="none"/><circle cx="8" cy="18" r="1.5" fill="currentColor" stroke="none"/><circle cx="5.6" cy="8.2" r="1.5" fill="currentColor" stroke="none"/></svg>',
  moyeux: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" class="size-4"><circle cx="12" cy="12" r="5.6"/><circle cx="12" cy="12" r="1.9"/><path d="M12 6.4V4M12 20v-2.4M6.4 12H4M20 12h-2.4M8 8l-1.7-1.7M17.7 17.7 16 16M16 8l1.7-1.7M6.3 17.7 8 16"/></svg>'
};
var partOf = (target) => target.startsWith("cerclage") ? "cerclage" : target.startsWith("tetes") ? "tetes" : target;
var swatchStyle = (f) => f.neo || f.multi ? `background-image:url(${f.neo ? assets().neo : assets().multi});background-size:cover;background-position:center` : `background:${f.hex || "#141414"}`;
var checkSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="size-4 shrink-0"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
var FalcoConfigurator = class extends HTMLElement {
  connectedCallback() {
    this.mode = this.dataset.mode || "uni";
    try {
      this.offers = JSON.parse(this.dataset.offers || "{}");
    } catch {
      this.offers = {};
    }
    this.selection = defaultSelection(this.mode);
    this.active = modes.find((m) => m.id === this.mode).categories[0].target;
    this.wheel = this.querySelector("falco-wheel-3d");
    this.status = this.querySelector("[data-3d-status]");
    this.addEventListener("falco:3d-status", (e) => {
      if (this.status) this.status.textContent = this.status.dataset[e.detail] || this.status.dataset.loading;
    });
    this.addEventListener("falco:added", () => this.added(true));
    this.render();
  }
  get current() {
    return modes.find((m) => m.id === this.mode);
  }
  get cat() {
    return this.current.categories.find((x) => x.target === this.active) || this.current.categories[0];
  }
  switchMode(id) {
    this.mode = id;
    this.selection = defaultSelection(id);
    this.active = this.current.categories[0].target;
    this.added(false);
    this.render();
  }
  pick(f) {
    this.selection = { ...this.selection, [this.cat.target]: f };
    this.added(false);
    this.render();
  }
  added(on) {
    const b = this.querySelector("[data-add]");
    if (!b) return;
    b.classList.toggle("bg-graphite", on);
    b.classList.toggle("bg-violet", !on);
    b.classList.toggle("hover:bg-violet-900", !on);
    b.querySelector("[data-add-label]").textContent = on ? window.Falco.strings.added : window.Falco.strings.add;
    b.querySelector("[data-icon-bag]").hidden = on;
    b.querySelector("[data-icon-check]").hidden = !on;
  }
  applyOffer() {
    const o = this.offers[this.mode];
    if (!o) return;
    const money = window.Falco?.formatMoney || ((c2) => `${(c2 / 100).toFixed(2).replace(".", ",")} €`);
    const id = this.querySelector("[data-offer-id]");
    if (id && o.id) id.value = o.id;
    const price = this.querySelector("[data-offer-price]");
    if (price) price.textContent = money(o.price);
    const name = this.querySelector("[data-offer-name]");
    if (name && o.title && !name.dataset.fixed) name.textContent = o.title;
    const form = this.querySelector("form[data-ajax-cart]");
    if (form && o.title && !form.dataset.fixedTitle) form.dataset.productTitle = o.title;
  }
  render() {
    this.wheel?.apply(this.mode, this.selection);
    this.applyOffer();
    const modesEl = this.querySelector("[data-modes]");
    modesEl.replaceChildren(...modes.map((m) => {
      const on = m.id === this.mode;
      const b = document.createElement("button");
      b.type = "button";
      b.role = "tab";
      b.setAttribute("aria-selected", on);
      b.className = `rounded-card border p-3.5 text-left transition-colors ${on ? "border-graphite bg-graphite text-white" : "border-hair bg-white hover:border-graphite"}`;
      b.innerHTML = `<span class="flex items-center justify-between gap-2"><span class="text-[0.875rem] font-bold">${m.label}</span>${on ? checkSvg : ""}</span><span class="mt-1 block text-[0.75rem] leading-snug ${on ? "text-white/65" : "text-gris"}">${m.description}</span>`;
      b.addEventListener("click", () => this.switchMode(m.id));
      return b;
    }));
    const partsEl = this.querySelector("[data-parts]");
    partsEl.replaceChildren(...this.current.categories.map((cat) => {
      const on = cat.target === this.cat.target, fin = this.selection[cat.target];
      const b = document.createElement("button");
      b.type = "button";
      b.role = "tab";
      b.setAttribute("aria-selected", on);
      b.className = `flex shrink-0 items-center gap-2.5 rounded-full border py-1.5 pl-1.5 pr-4 transition-colors ${on ? "border-graphite bg-graphite text-white" : "border-hair bg-white hover:border-graphite"}`;
      b.innerHTML = `<span class="relative size-8 shrink-0 overflow-hidden rounded-full bg-papier"><img src="${thumbUrl(cat.thumb)}" alt="" width="32" height="32" class="absolute inset-0 size-full object-cover"></span><span class="text-[0.8125rem] font-semibold whitespace-nowrap">${cat.label}</span>${fin ? `<span class="block size-3.5 rounded-full ring-1 ring-inset ring-black/15" style="${swatchStyle(fin)}"></span>` : ""}`;
      b.addEventListener("click", () => {
        this.active = cat.target;
        this.render();
      });
      return b;
    }));
    this.querySelector("[data-part-icon]").innerHTML = PART_ICON[partOf(this.cat.target)] || "";
    this.querySelector("[data-part-label]").textContent = this.cat.label;
    this.querySelector("[data-finish-name]").textContent = this.selection[this.cat.target]?.name || "";
    const finEl = this.querySelector("[data-finishes]");
    finEl.replaceChildren(...this.cat.finishes.map((f) => {
      const on = this.selection[this.cat.target]?.name === f.name;
      const li = document.createElement("li");
      li.innerHTML = `<button type="button" aria-pressed="${on}" aria-label="${this.cat.label} : ${f.name}" class="group flex w-full flex-col items-center gap-1.5"><span class="block aspect-[4/3] w-full rounded-lg ring-1 ring-inset ring-black/15 transition-transform duration-200 group-hover:scale-110 ${on ? "ring-2 ring-graphite ring-offset-2 ring-offset-white" : ""}" style="${swatchStyle(f)}"></span><span class="text-center text-[0.625rem] leading-tight ${on ? "font-bold text-graphite" : "text-gris"}">${f.name}</span></button>`;
      li.querySelector("button").addEventListener("click", () => this.pick(f));
      return li;
    }));
    const sum = this.querySelector("[data-summary]");
    sum.replaceChildren(...this.current.categories.map((cat) => {
      const f = this.selection[cat.target];
      const d = document.createElement("div");
      d.className = "flex items-center justify-between gap-3 text-[0.8125rem]";
      d.innerHTML = `<dt class="text-gris">${cat.label}</dt><dd class="flex items-center gap-2 font-semibold text-graphite">${f ? `<span class="block size-3.5 rounded-full ring-1 ring-inset ring-black/15" style="${swatchStyle(f)}"></span>${f.name}` : ""}</dd>`;
      return d;
    }));
    const props = this.querySelector("[data-properties]");
    if (props) {
      props.replaceChildren();
      const add = (k, v) => {
        const i = document.createElement("input");
        i.type = "hidden";
        i.name = `properties[${k}]`;
        i.value = v;
        props.appendChild(i);
      };
      add("Mode", this.current.label);
      this.current.categories.forEach((cat) => add(cat.label, this.selection[cat.target]?.name || ""));
    }
  }
};
customElements.define("falco-config", FalcoConfigurator);
